import { getGridGeometry } from "./grid.js";

const gridGeometry = () => getGridGeometry();
let svgEl;

/**
 * Updates the path-layer SVG from list of indices
 */
export function updatePath(indices) {
  const pathEl = svgEl.children[0];
  if (pathEl == null) return;

  const points = indices.map((index) => {
    return {
      x: gridGeometry()[index].cx,
      y: gridGeometry()[index].cy
    }
  });
  const d = points.map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`).join(" ");
  pathEl.setAttribute("d", d);
}

export function createSelectionPath(width, height) {
  svgEl = document.getElementById("path-layer");
  svgEl.setAttribute("viewBox", `0 0 ${width} ${height}`);
  const pathEl = document.createElementNS("http://www.w3.org/2000/svg", "path");
  pathEl.setAttribute("fill", "none");
  pathEl.setAttribute("stroke", "#052f4a");
  pathEl.setAttribute("stroke-width", "18");
  pathEl.setAttribute("stroke-linecap", "round");
  pathEl.setAttribute("stroke-linejoin", "round");
  svgEl.appendChild(pathEl);
}
